import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { LandingBrand } from './landing-brand';

const footerLinks = [
  { href: '/sellers', label: 'For Sellers' },
  { href: '/buyers', label: 'For Buyers' },
  { href: '/solutions', label: 'Solutions' },
  { href: '/about-us', label: 'About' },
  { href: '/press', label: 'Press' },
  { href: '/contact', label: 'Contact' },
];

export function LandingFooter() {
  return (
    <section className="border-t border-white/10 bg-[#151515] px-5 py-20 text-white sm:px-6">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto max-w-xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
            Move inventory. Get paid.
          </h2>
          <p className="mt-4 text-white/65">Start selling or buying today.</p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              href="/contact"
              className="inline-flex h-11 items-center justify-center rounded-md bg-white px-6 text-sm font-medium text-[#171717] transition-colors hover:bg-white/90"
            >
              Sell Inventory
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </Link>
            <Link
              href="/stores/join-os/application"
              className="inline-flex h-11 items-center justify-center rounded-md border border-white/25 px-6 text-sm font-medium transition-colors hover:bg-white/10"
            >
              Apply to Buy
            </Link>
          </div>
        </div>

        <footer className="mt-20 flex flex-col items-center justify-between gap-7 border-t border-white/10 pt-10 md:flex-row">
          <LandingBrand tone="inverse" />
          <nav
            className="flex flex-wrap justify-center gap-x-7 gap-y-3 text-sm text-white/60"
            aria-label="Footer navigation"
          >
            {footerLinks.map((link) => (
              <Link key={link.href} href={link.href} className="transition-colors hover:text-white">
                {link.label}
              </Link>
            ))}
          </nav>
          <p className="text-sm text-white/60">© 2026 OS Group. All rights reserved.</p>
        </footer>
      </div>
    </section>
  );
}
